import Layout from '@/layout'

const legacyRoutes = [
    {
        path: '/member',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'tinggo360mlist',
                name: 'memberList',
                component: () => import('@/views/page/member/memberList'),
                meta: { title: '会员管理', icon: 'user' }
            },
            {
                path: 'detail',
                name: 'memberDetail',
                component: () => import('@/views/page/member/memberDetail'),
                meta: { title: '会员详情', icon: 'user' }
            }
        ]
    },
    {
        path: '/order',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'tinggoorderlist',
                name: 'orderList',
                component: () => import('@/views/page/order/orderList'),
                meta: { title: '订单管理', icon: 'shopping' }
            },
            {
                path: 'detail',
                name: 'orderDetail',
                component: () => import('@/views/page/order/orderDetail'),
                meta: { title: '订单详情', icon: 'shopping' }
            },
            {
                path: 'refund/list',
                name: 'refundList',
                component: () => import('@/views/page/order/refundList'),
                meta: { title: '退票申请列表', icon: 'shopping' }
            },
            {
                path: 'change/list',
                name: 'changeList',
                component: () => import('@/views/page/order/changeList'),
                meta: { title: '改签申请列表', icon: 'shopping' }
            }
        ]
    },
    {
        path: '/finance',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'transaction/list',
                name: 'transactionList',
                component: () => import('@/views/page/finance/transactionList'),
                meta: { title: '交易记录', icon: 'money' }
            }
        ]
    },
    {
        path: '/risk',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'anomaly/list',
                name: 'anomalyList',
                component: () => import('@/views/page/risk/anomalyList'),
                meta: { title: '异常检测', icon: 'bug' }
            },
            {
                path: 'operation/log',
                name: 'riskOperationLog',
                component: () => import('@/views/page/risk/operationLog'),
                meta: { title: '操作日志', icon: 'log' }
            },
            {
                path: 'login/log',
                name: 'riskLoginLog',
                component: () => import('@/views/page/risk/loginLog'),
                meta: { title: '登录日志', icon: 'log' }
            },
            {
                path: 'order/trace/fklist',
                name: 'orderRiskTraceList',
                component: () => import('@/views/page/risk/orderRiskTraceList'),
                meta: { title: '订单风控列表', icon: 'list' }
            },
            {
                path: 'order/trace',
                name: 'orderRiskTrace',
                component: () => import('@/views/page/risk/orderRiskTrace'),
                meta: { title: '订单风控查询', icon: 'search' }
            },
            {
                path: 'policy/config',
                name: 'policyConfig',
                component: () => import('@/views/page/risk/policyConfig'),
                meta: { title: '策略配置', icon: 'setting' }
            },
            {
                path: 'listManage',
                name: 'listManage',
                component: () => import('@/views/page/risk/listManage'),
                meta: { title: '名单管理', icon: 'list' }
            }
        ]
    }
]

export default legacyRoutes
